export default "__VITE_PUBLIC_ASSET__1b5e2e46__"